import React from 'react';
import { Skeleton } from '@mui/material';
import { LoadingCompanyCardContainer, SkeletonTagsContainer, StyledSkeletonTag } from './styles';

const LoadingCompanyCard = () => {
    return (
        <LoadingCompanyCardContainer>
            <Skeleton variant='text' width={'50%'} height={16} sx={{ marginBottom: 1 }} />
            <Skeleton variant='rounded' width={'80%'} height={24} sx={{ marginBottom: 4 }} />
            <SkeletonTagsContainer>
                <StyledSkeletonTag variant='rounded' width={'120px'} />
                <StyledSkeletonTag variant='rounded' width={'150px'} />
                <StyledSkeletonTag variant='rounded' width={'220px'} />
                <StyledSkeletonTag variant='rounded' width={'80px'} />
            </SkeletonTagsContainer>
        </LoadingCompanyCardContainer>
    );
};

export { LoadingCompanyCard };
